/** @jsx h */
import { h } from 'preact'

import ProofPoint from '../claims/ProofPoint'
import t from '../../../utils/translate'

const ProofPointsSection = props => {
  const { proofPoints, onProofPointClick, analyticsContext } = props

  const proofPointsList = proofPoints.map(proofPoint =>
    <li
      class='CapsuleList-item'
      key={proofPoint.name}
    >
      <div class='CapsuleList-inner'>
        <ProofPoint {...proofPoint} onClick={onProofPointClick} analyticsContext={analyticsContext} />
      </div>
    </li>
  )

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>{t('proof_points.js.title')}</h3>
      <ul class='CapsuleList'>{proofPointsList}</ul>
    </section>
  )
}

export default ProofPointsSection
